"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _exponent=_interopRequireDefault(require("./exponent"));var precisionRound=function precisionRound(_step,_max){var step=Math.abs(_step),max=Math.abs(_max)-step;return Math.max(0,(0,_exponent.default)(max)-(0,_exponent.default)(step))+1};var _default=precisionRound;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/number-converter/precision-round.js
// module id = KYLs
// module chunks = 5